export const isOverflowX = (element: HTMLElement) =>
  element.scrollWidth > element.clientWidth

export default isOverflowX
